import React from "react";

import Box from "@mui/material/Box";

import { useMovie } from "../movie/MovieProvider";
import { useMovieSetter } from "../movie/MovieProvider";

import VEElement from "./VEElement";
import VENewElementDialog from "./VENewElementDialog";
import VEVariablesDialog from "./VEVariablesDialog";

import { ReactSortable } from "react-sortablejs";

import MovieIcon from '@mui/icons-material/Movie';
import TvIcon from '@mui/icons-material/Tv';
import AddToQueueIcon from '@mui/icons-material/AddToQueue';
import AddIcon from '@mui/icons-material/Add';
import TableViewIcon from '@mui/icons-material/TableView';
import IosShareIcon from '@mui/icons-material/IosShare';


export default function VEMovieMenuPanel(props) {

    const [openNewDialog, setOpenNewDialog] = React.useState(false);
    const [openVariablesDialog, setOpenVariablesDialog] = React.useState(false);
    const [openDestinationsDialog, setOpenDestinationsDialog] = React.useState(false);

    const movie = useMovie();
    const setMovie = useMovieSetter();

    const selectedClasses = "bg-yellow-200";

    const isMovieSelected = (movie.selected && movie.selected.type === "movie") ? selectedClasses : "";

    let destinationsArray = [];
    const numberOfVariables = movie.movieObject.variables ? Object.keys(movie.movieObject.variables).length : 0;
    const numberOfDestinations = (() => {
        if (Array.isArray(movie.movieObject.exports) && movie.movieObject.exports.length > 0) {
            const firstExport = movie.movieObject.exports[0];

            if (typeof firstExport === "object") {
                destinationsArray = firstExport.destinations || [];
                return firstExport.destinations ? Object.keys(firstExport.destinations).length : 0;
            }
        }

        return 0;
    })();

    return (
        <Box className="m-1 w-2/12 border border-gray-200 overflow-y-auto text-sm">
            <Box onClick={movieClicked} className={"cursor-pointer p-1 flex items-center " + isMovieSelected}>
                <MovieIcon sx={{ fontSize: "16px" }} /><span className="ml-2 font-semibold">Movie template</span>
            </Box>
            <Box className="mt-3 ml-2">
                <TableViewIcon sx={{ fontSize: "16px" }} className="" />
                <span className="ml-1 font-semibold cursor-pointer" onClick={() => setOpenVariablesDialog(true)}>
                    Variables ({numberOfVariables})
                </span>
            </Box>
            <Box className="mt-3 ml-2">
                <IosShareIcon sx={{ fontSize: "16px" }} className="" />
                <span className="ml-1 font-semibold cursor-not-allowed">
                    Destinations ({numberOfDestinations})
                </span>
            </Box>
            <Box className="mt-3 ml-3">
                <details open>
                    <summary><span className="pl-2 font-semibold cursor-pointer">Scenes</span></summary>
                    {listOfScenes()}
                </details>

            </Box>
            <Box className="mt-3 ml-3">
                <details open>
                    <summary><span className="pl-2 font-semibold cursor-pointer">Movie elements</span></summary>
                    {listOfElements(movie.movieObject, -1)}
                </details>
            </Box>
            {
                openNewDialog && <VENewElementDialog key="add-new-element-dialog" onClose={addNewElement} />
            }
            <VEVariablesDialog key="variables-dialog" open={openVariablesDialog} variablesObject={movie.movieObject.variables} onClose={closeVariablesDialog} />
        </Box>
    );

    function listOfScenes() {

        const scenes = JSON.parse(JSON.stringify(movie.movieObject.scenes));//movie.movieObject.scenes || [];

        return (
            <Box>
                <ReactSortable list={scenes} setList={() => { }} animation={200} ghostClass="bg-gray-100"
                    onEnd={onSceneOrderChange}>
                    {
                        (Array.isArray(scenes)) && scenes.map((scene, index) => {
                            const title = scene.comment ?? ("Scene #" + (index + 1));
                            const isSelected = movie.isSelectedById(scene.id) ? selectedClasses : "";
                            return (
                                <details open key={index} className="border-l-2 ml-1 pl-3 pt-1">
                                    <summary className={"cursor-pointer p-1 truncate " + isSelected}>
                                        <span id={scene.id} onClick={sceneClicked}>
                                            <TvIcon sx={{ fontSize: "16px" }} className="ml-1" /> <span className="ml-1 font-semibold">{title}</span>
                                        </span>
                                    </summary>
                                    {listOfElements(scene, index)}
                                </details>
                            );
                        })
                    }
                </ReactSortable>
                <Box onClick={addNewScene} className="ml-1 border-l-2 pl-8 pt-5 flex items-center text-white hover:text-black cursor-pointer truncate">
                    <AddToQueueIcon sx={{ fontSize: "16px", color: "#333" }} /> <span className="ml-2 pt-1">Add a new scene</span>
                </Box>
            </Box>
        );
    }

    function listOfElements(scene, sceneIndex) {

        const elements = JSON.parse(JSON.stringify(scene.elements));// //scene.elements || [];

        return (
            <Box>
                <ReactSortable id={sceneIndex} list={elements} setList={() => { }} animation={200} ghostClass="bg-gray-100"
                    onEnd={onElementsOrderChange} group="elements">
                    {
                        (Array.isArray(elements)) && elements.map((element, index) => {
                            let info = VEElement(element, { sx: { fontSize: "16px" } });
                            const isSelected = (movie.isSelectedById(element.id)) ? selectedClasses : "";
                            return (
                                <Box key={index} id={element.id} data-scene={scene.id} onClick={elementClicked}
                                    className={"border-l-2 ml-2 pl-2.5 flex items-center cursor-pointer p-1 truncate " + isSelected}>
                                    {info.icon}
                                    <span className="ml-1">{info.title}</span>
                                </Box>
                            );
                        })
                    }
                </ReactSortable>
                <Box onClick={openAddNewElementDialog} data-scene={scene.id}
                    className="border-l-2 ml-2 pt-1 pl-2.5 flex items-center text-white hover:text-black cursor-pointer truncate">
                    <AddIcon sx={{ fontSize: "16px", color: "#DDD" }} />
                    <span className="ml-1">Add a new element</span>
                </Box>
                <Box className="ml-2 border-l-2 border-b-2 h-1 w-2"></Box>
            </Box>
        );
    }

    

    function movieClicked(event) {
        // select the movie object
        event.preventDefault();

        setMovie({
            type: "selectItemByCoords",
            sceneIndex: -1,
            elementIndex: -1
        });
    }

    function sceneClicked(event) {
        // select the scene item
        event.preventDefault();
        const clickedSceneId = event.currentTarget.id;
        // console.log("User clicked scene #", clickedSceneId);

        setMovie({
            type: "selectItemById",
            itemId: clickedSceneId
        });
    }

    function elementClicked(event) {
        // select the element item
        event.preventDefault();
        const clickedElementId = event.currentTarget.id;
        
        console.log("User clicked element #", clickedElementId);

        setMovie({
            type: "selectItemById",
            itemId: clickedElementId
        });
    }

    function addNewScene() {
        // add a new scene
        const currentScenes = movie.movieObject.scenes;
        const newList = [
            ...currentScenes,
            { comment: "New scene" }
        ];
        setMovie({
            type: "updateScenes",
            scenes: newList
        });
    }

    function openAddNewElementDialog(event) {
        event.preventDefault();

        // get the scene where the new element will be added
        const sceneToAddElementTo = event.currentTarget.getAttribute("data-scene");
        // console.log("sceneToAddElementTo", sceneToAddElementTo);

        // select the scene
        setMovie({
            type: "selectItemById",
            itemId: sceneToAddElementTo
        });

        // open the dialog
        setOpenNewDialog(true);
    }

    function addNewElement(elementType) {
        setOpenNewDialog(false);
        // console.log("addNewElement", elementType, movie.selected);

        if (elementType && movie.selected) {
            const currentElements = movie.selected.pointer.elements;
            // console.log("currentElements", currentElements);

            // add the new element
            let newElements;

            if (typeof elementType === "object") {
                newElements = [
                    ...currentElements,
                    elementType
                ];
            }
            else if (typeof elementType === "string") {
                newElements = [
                    ...currentElements,
                    { type: elementType }
                ];
            }

            // update the scene elements
            setMovie({
                type: "updateProperties",
                itemId: movie.selected.itemId,
                properties: {
                    elements: newElements
                }
            });
        }
    }

    function onSceneOrderChange(event) {
        // move the item to the new index
        let movieItemCopy = movie.getItemCopyByCoords(-1, -1);
        let newList = movieItemCopy.pointer.scenes;

        const movedItem = newList[event.oldIndex];
        newList.splice(event.oldIndex, 1);
        newList.splice(event.newIndex, 0, movedItem);

        // update movieJSON
        setMovie({
            type: "updateProperties",
            itemId: movieItemCopy.itemId,
            properties: {
                scenes: newList
            }
        });

        setMovie({
            type: "selectItemByCoords",
            sceneIndex: event.newIndex,
            elementIndex: -1
        });
    }

    function onElementsOrderChange(event) {

        const fromSceneIndex = event.from.id, fromElementIndex = event.oldIndex;
        const toSceneIndex = event.to.id, toElementIndex = event.newIndex;

        let fromSceneItem = movie.getItemCopyByCoords(fromSceneIndex, -1); //movie.movieObject.scenes[fromSceneIndex].elements;
        let toSceneItem = movie.getItemCopyByCoords(toSceneIndex, -1); //movie.movieObject.scenes[toSceneIndex].elements;

        if (!fromSceneItem || !toSceneItem) {
            // if any of the scenes does not exist
            return;
        }

        const fromSceneElements = fromSceneItem.pointer.elements;
        const toSceneElements = toSceneItem.pointer.elements;

        const movedElement = fromSceneElements[fromElementIndex];

        if (fromSceneIndex === toSceneIndex) {
            // move inside the same scene
            toSceneElements.splice(fromElementIndex, 1);
            toSceneElements.splice(toElementIndex, 0, movedElement);

            // update the scene elements
            setMovie({
                type: "updateProperties",
                itemId: fromSceneItem.itemId,
                properties: {
                    elements: toSceneElements
                }
            });
        } else {
            // move to a different scene
            fromSceneElements.splice(fromElementIndex, 1);
            toSceneElements.splice(toElementIndex, 0, movedElement);

            // update the scene elements
            setMovie({
                type: "updateProperties",
                itemId: fromSceneItem.itemId,
                properties: {
                    elements: fromSceneElements
                }
            });

            setMovie({
                type: "updateProperties",
                itemId: toSceneItem.itemId,
                properties: {
                    elements: toSceneElements
                }
            });
        }

        setMovie({
            type: "selectItemByCoords",
            sceneIndex: toSceneIndex,
            elementIndex: toElementIndex
        });
    }

    function closeVariablesDialog(variablesObject) {
        console.log("closeVariablesDialog: ", variablesObject);
        setOpenVariablesDialog(false);

        // update the variables
        setMovie({
            type: "updateMovieProperty",
            property: "variables",
            value: variablesObject
        });
    }

    function closeDestinationsDialog(destinationsObject) {
        console.log("closeDestinationsDialog: ", destinationsObject);
        setOpenDestinationsDialog(false);
    }
}